export default __webpack_public_path__ + "static/media/364.9a7fb172.png";